import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getServicesURL } from '../utils/api';

const useGetServices = ({ 
        page = 1,
        limit = 10,
        keyword,
        showArchived = false,
        excludeCover = false,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingServices, setGettingServices ] = useState(false);
    const [ services, setServices ] = useState([]);
    const [ totalServices, setTotalServices ] = useState(0);
    const [ gettingServicesReqSuccess, setGettingServicesReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingServices) {
            axios.get(getServicesURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword,
                    showArchived,
                    excludeCover,
                }
            }).then(result => {
                setGettingServices(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalServices(result.data.total);
                    }
                    setGettingServicesReqSuccess(true);
                    setServices(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingServicesReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingServicesReqSuccess(false);
                setGettingServices(false);
            });
        }
    }, [gettingServices]);

    return { services, totalServices, gettingServices, setGettingServices, gettingServicesReqSuccess };
}

export default useGetServices;